<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="visible"
      width="710px"
      center
      v-loading="remarkLoading"
    >
      <el-row :gutter="20" style="margin-bottom: 12px">
        <el-col :span="18">
          <el-select :popper-append-to-body="false" v-model="sellerWordsInfoTemp" filterable @change="updateRemark" placeholder="常用备注选择" :clearable="true">
            <el-option
              v-for="(item, key) in remarkData"
              :key="key"
              :label="item.contents"
              :value="item.contents">
              <div>
                <span style="float: left;width:87%;oveflow:hidden;text-overflow: ellipsis; overflow: hidden;" :title="item.contents">{{ item.contents }}</span>
                <span class="y-ml-20"  @click.stop="deleteRemark(remarkData[key])">删除</span>
              </div>
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6"><el-button type="text" @click="showRemarkDialog()">添加自定义备注</el-button></el-col>
      </el-row>
      <el-form label-width="0px" :model="currentRow" ref="editSellerRemarkForm">
        <el-form-item>
          <el-input type="textarea" style="width:100%;" v-model="currentRow.mallRemark" :autosize="{minRows: 6, maxRows: 10}" maxlength="100" show-word-limit placeholder="请输入备注，100字以内"></el-input>
         </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveInfo">保存</el-button>
        <el-button @click="closeDialog">取消</el-button>
      </div>
    </el-dialog>
    <!-- 添加备注弹层 -->
    <el-dialog title="添加备注" center :visible.sync="remarkdialogFormVisible" width="40%" :before-close="resetRemarkForm" :close-on-click-modal="false" >
      <el-form :model="remarkForm" prop="remark" :rules="remarkFormRule" ref="remarkForm">
        <el-form-item label="备注内容" prop="remark">
          <el-input type="textarea" v-model="remarkForm.remark" :autosize="{minRows: 6, maxRows: 10}"  autocomplete="off" maxlength="100" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRemarkFn">确 定</el-button>
        <el-button @click="resetRemarkForm">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addCustomRemarkApi, deleteCustomRemarkApi, getCustomRemarkListApi, opUpdateApi, opUpdatePrintedApi } from '../../../../api/waybillPrint/customPrint';
export default {
  components: {},
  props: {
    currentRow: {
      type: Object
    },
    showRemark: {
      type: Boolean
    },
    value: {
      type: Boolean,
      default: false
    },
    platformType: {
      type: String,
      default: ''
    },
    orderFlagList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    title: {
      type: String
    },
    curComponent: {
      type: String
    }
  },
  mounted() {
    this.getRemarkList();
  },
  data() {
    return {
      remarkLoading: false,
      remarkData: [],
      remarkForm: {
        remark: ''
      },
      remarkFormRule: {
        remark: [{ required: true, message: '请输入备注内容', trigger: 'blur' }]
      },
      remarkdialogFormVisible: false,
      popoverRmark: false,
      placeSelected: '',
      sellerWordsInfoTemp: '',
      props: {
        label: 'name',
        value: 'code'
      },
      visible: false
    };
  },
  methods: {
    // 获取备注列表
    getRemarkList() {
      this.remarkLoading = true;
      getCustomRemarkListApi().then((res) => {
        if (res.message === 'ok') {
          this.remarkLoading = false;
          this.remarkData = res.data;
        }
      }).finally(()=>{
        this.remarkLoading = false;
      });
    },
    // 显示添加备注提示框
    showRemarkDialog() {
      if (this.remarkData.length < 20) {
        this.remarkdialogFormVisible = true;
      } else {
        this.$message('自定义备注最多20条。');
      }
    },
    // 用户选择消息模板后
    updateRemark(val) {
      this.currentRow.mallRemark = val.slice(0, 100);
    },
    // 删除备注列表
    deleteRemark(row) {
      this.sellerWordsInfoTemp = '';
      deleteCustomRemarkApi([row.id]).then(res => {
        if (res.message === 'ok') {
          this.sellerWordsInfoTemp = '';
          this.getRemarkList();
        }
      });
    },
    saveInfo() {
      let params = {
        ...this.currentRow,
        orderProducts: this.currentRow.goodDetails
      }
      delete params.goodDetails;
      this.$refs['editSellerRemarkForm'].validate(valid => {
        if (valid) {
          this.remarkLoading = true;
          if(this.curComponent === 'APPLY_ORDER') {
            opUpdateApi(params).then((response) => {
              if (response.status === 200) {
                this.$message.success('备注修改成功');
                this.$emit('updateRemark', params.mallRemark)
              } else {
                this.$message.error(response.message);
              }
            }).catch((err) => {
              this.$message.error(err.error);
            }).finally(() => {
              this.remarkLoading = false;
              this.$emit('update:showRemark', false);
            });
          } else {
            opUpdatePrintedApi(params).then((response) => {
              if (response.status === 200) {
                this.$message.success('备注修改成功');
                this.$emit('updateRemark', params.mallRemark)
              } else {
                this.$message.error(response.message);
              }
            }).catch((err) => {
              this.$message.error(err.error);
            }).finally(() => {
              this.remarkLoading = false;
              this.$emit('update:showRemark', false);
            });
          }
        }
      });
    },
    closeDialog() {
      this.$emit('update:showRemark', false);
    },
    resetRemarkForm() {
      this.$refs.remarkForm.resetFields();
      this.remarkdialogFormVisible = false;
    },
    submitRemarkFn() {
      this.$refs.remarkForm.validate((valid) => {
        if (valid) {
          let params = [{contents: this.remarkForm.remark}];
          addCustomRemarkApi(params).then(res => {
            if (res.message === 'ok') {
              this.resetRemarkForm();
              this.$message.success('添加备注成功');
              this.getRemarkList(); // 更新备注列表
            } else {
              this.$message.error('添加备注信息失败！');
            }
          });
        }
      });
    }
  },
  watch: {
    visible(val) {
      if(!val) {
        this.$emit('update:showRemark', false);
      }
    },
    showRemark(val) {
      this.visible = val;
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-select--small {
  width: 490px;
}
/deep/ .el-select-dropdown  {
  width: 490px;
}
</style>
